<template>
	<div class="w-full">
		<NewDatatable
			v-model="attendances"
			:headers="headers"
			:checkbox="false"
			empty-text="NÃO HÁ REGISTROS DE JORNADAS"
			:row-colors="{
				pending: 'var(--priorityBackgroundColor)',
				ready: 'var(--successBackgroundColor)',
			}"
			@click="SelectAttendance"
		>
			<template #row="{ item }">
				<div class="datatable-cell date">
					<b>
						{{ item.date }}
					</b>
				</div>
				<div class="datatable-cell time">
					<b>
						{{ item.time }}
					</b>
				</div>
				<div class="datatable-cell name">
					<b>{{
						item.proceeding_name ?? 'SEM PROCEDIMENTO VINCULADO'
					}}</b>
				</div>
				<div
					class="datatable-cell status"
					:class="item.status"
				>
					<b>{{ item.status_descricao.toUpperCase() }}</b>
				</div>
			</template>
		</NewDatatable>

		<AttendanceModal
			v-if="showAttendanceModal"
			origin="journey"
			:attendance_id="selected_attendance_id"
			@close="showAttendanceModal = false"
		/>
	</div>
</template>

<script>
	import Swal from 'sweetalert2'
	import { mapActions, mapGetters } from 'vuex'
	import AttendanceModal from '@/components/shared/AttendanceModal'

	export default {
		name: 'Journey',
		components: {
			AttendanceModal,
		},
		props: {
			patient: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				is_load: false,
				history: null,
				app_url: process.env.VUE_APP_APP_URL,
				report_url: '',
				ended_report: '',
				report_code: '',
				headers: [
					{ text: 'DATA', value: 'data', width: '7rem' },
					{ text: 'HORA', value: 'hora', width: '5rem' },
					{ text: 'PROCEDIMENTO', value: 'proceeding' },
					{
						text: 'STATUS',
						value: 'status_description',
						width: '14rem',
					},
				],
				timeline_data: {
					patient: {},
					logs: [],
					journey_id: null,
					scheduling_id: null,
				},
				sortedBy: {
					column: 'data',
					direction: 'DESC',
					icon: 'fa-chevron-down',
				},
				selected_attendance_id: null,
				attendances: [],
				showAttendanceModal: false,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			GetPatientAttendances() {
				const vm = this

				vm.StartLoading()

				vm.attendances = []

				return window.api
					.call('post', '/get-attendances', {
						account_id: vm.requester_selected_id,
						patient_id: `${vm.patient.id}`,
						light_data: true,
						latest_first: true,
					})
					.then(({ data }) => {
						if (data.response) {
							vm.attendances = data.attendances
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
			},
			SelectAttendance(attendance) {
				this.selected_attendance_id = attendance.id

				this.showAttendanceModal = true
			},
		},
		async beforeMount() {
			this.is_load = true
			await this.GetPatientAttendances()
			this.is_load = false
		},
	}
</script>

<style></style>
